import React from 'react';
import { ITemplateState } from 'components/Cart';
import { BaseComponent } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import MultiStep from './MultiStep';
import Footer from 'components/Cart/Footer';
import Header from './Header';
import OneClickBuy from './OneClickBuy';

const styles = require('./theme.css');

interface IState extends ITemplateState {

}

export default class WidgetTheme extends BaseComponent<IState, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    window.parent.postMessage('EdzWidgetLoaded', '*');
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart } = this.state;
    const product = cart.products[0];

    return (
      <div className={`${styles.component} theme-hotsite`}>
        <div className='chk-main-container'>
          <div className='chk-content-container'>
            <div className='chk-form-container'>
              <Header cart={cart} />
              {cart.config.isOneClick
                ? <OneClickBuy onPay={this.props.onPay} hiddenFooter />
                : <MultiStep product={product} onPay={this.props.onPay} />
              }
              <div className='links'>
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Widget/index.tsx